import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaLock } from 'react-icons/fa'

import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { Button, Dialog } from '@material-ui/core'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import useSubmittedProposals from '../../hooks/useSubmittedProposals'
import { downloadTextFiles } from './utils/fileDownload'
import styled from 'styled-components'
import usePasswords from '../../hooks/usePasswords'

const useStyles = makeStyles(theme => ({
  textField: {
    width: '100%'
  },
  dialogPaper: {
    borderRadius: 0,
    backgroundColor: theme.modeColors.inputBackground,
    width: '500px'
  },
  dialogTitle: {
    borderBottom: '1px solid #e0e2e4',
    margin: 0,
    padding: '20px 16px 18px'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#353c43'
  }
}))

function getDownloadData(data) {
  if (!Array.isArray(data)) {
    return []
  }
  return data.map(doc => {
    return {
      path: `${doc.pseudonym} (${doc.id})/${doc.pseudonym}.txt`,
      content: doc.author
    }
  })
}

const DownloadAuthorTextFiles = ({ setLoading }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [password, setPassword] = React.useState('')
  const [showPassword, setShowPassword] = React.useState(false)
  const [error, setError] = React.useState('')
  const { authorData } = useSubmittedProposals()
  const { passwordToDownloadAuthor } = usePasswords()
  const classes = useStyles()
  const { t } = useTranslation('proposals')
  const passwordInputRef = React.useRef(null)

  const data = getDownloadData(authorData)

  const handleChange = event => {
    setPassword(event.target.value)
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = event => {
    event.preventDefault()
  }

  const handleDownload = event => {
    if (!password) return
    if (password !== passwordToDownloadAuthor.value) {
      setError('Password is incorrect')
      return
    }
    setLoading(true)
    setIsModalOpen(false)
    downloadTextFiles('Author.zip', data, setLoading)
  }

  return (
    <>
      <StyledButton onClick={() => setIsModalOpen(true)}>
        <span>{t('Authors and copyright')}</span>
        <FaLock style={{ width: 20, height: 20, color: 'red' }} />
      </StyledButton>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={isModalOpen}
        maxWidth="sm"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <h3 className="mb-0">{t('Password')}</h3>
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={() => setIsModalOpen(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p>{t('Please input password to download author information.')}</p>
          <p style={{ color: 'red' }}>{t(error)}</p>
          <FormControl className={clsx(classes.textField)} variant="outlined">
            <InputLabel htmlFor="password">{t('Password')}</InputLabel>
            <OutlinedInput
              id="password"
              type={showPassword ? 'text' : 'password'}
              name="password"
              autoFocus
              value={password}
              onChange={e => handleChange(e)}
              inputRef={passwordInputRef}
              onClick={() => passwordInputRef.current.focus()}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              className="mt-2"
            >
              {t('Download')}
            </Button>
          </FormControl>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DownloadAuthorTextFiles

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin: 0;
  padding: 10px 0;

  svg {
    margin-top: -5px;
    margin-left: 20px;
  }
`
